<template>
  <div class="text-center">
    <v-dialog persistent v-model="visible" width="800">
      <v-card class="not-margin pt-0 pr-0 pl-0">
        <v-toolbar dark color="primary">
          <div class="text-center">
            <v-icon>mdi-pencil</v-icon>
            {{ edit ? "Editar" : "Cadastrar" }} Período de Formação
          </div>
        </v-toolbar>
        <div class="container dialog">
          <v-form ref="form" v-if="visible">
            <v-row class="d-flex justify-center mt-7">
                <sigfoco-date-picker
                  v-model="content.dataInicio"
                  label="Início do Período*"
                  removeIcon
                  :dataEdicao="content.dataInicio"
                  outlined
                  dense
                  :rules="[
                    (v) => !!v || 'Campo obrigatório',
                    () => validateData() || 'A data de início do período não pode ser posterior à data de fim e o período deve ter pelo menos 3 dias.'
                  ]"
                ></sigfoco-date-picker>
                <sigfoco-date-picker
                  v-model="content.dataFim"
                  label="Fim do Período*"
                  removeIcon
                  :dataEdicao="content.dataFim"
                  outlined
                  dense
                  :rules="[
                    (v) => !!v || 'Campo obrigatório',
                    () => validateData() || 'A data de fim do período não pode ser posterior à data de inicio e o período deve ter pelo menos 3 dias.'
                  ]"
                ></sigfoco-date-picker>
            </v-row>
            <v-row class="d-flex justify-center mt-7">
              <v-col cols="12">
                <v-autocomplete
                  v-model="content.perfis"
                  :items="form.lists.listPerfis"
                  :item-text="'nome'"
                  :item-value="'id'"
                  :rules="[(p) => p.some(v => $required(v)) || 'Campo obrigatório']"
                  label="Perfil*"
                  multiple
                  outlined
                  dense
                  return-object
              ></v-autocomplete>
              </v-col>
            </v-row>
          </v-form>
        </div>
        <sigfoco-buttons
          @click="salvar()"
          @cancel="$emit('onClose')"
          :actionText="'Salvar'"
        ></sigfoco-buttons>
      </v-card>
    </v-dialog>
  </div>
</template>

<script>
import { DialogProps } from '~/commons/classes/dialog-props';
import { PeriodoFormacao } from '~/commons/classes/periodo-formacao';
import PeriodoFormacaoService from '~/services/manter-periodo-formacao.service';
import PermissaoService from '~/services/permissao.service';
import ManterPerfilService from '~/services/manter-perfil.service';

export default {
  props: new DialogProps(PeriodoFormacao),
  mixins: [PeriodoFormacaoService, PermissaoService, ManterPerfilService],
  data() {
    return {
      form: {
        lists: {
          listPerfis: [],
        },
      },
    };
  },
  methods: {
    payloadPeriodoFormacao() {
      return {
        perfis: this.content.perfis ? this.content.perfis.map((p) => p.id) : [],
        inicioPeriodo: this.content.inicioPeriodo,
        fimPeriodo: this.content.fimPeriodo,
      };
    },
    salvar() {
      const save = () => {          
        return this.$swal({
          text: `Deseja confirmar essa operação?`,
          type: "warning",
          showCancelButton: true,
          confirmButtonText: `Confirmar`,
          cancelButtonText: `Cancelar`,
        }).then(() => {
          const payload = new PeriodoFormacao(this.content).format();

          return this.edit
            ? this.$editarPeriodoFormacao(payload,payload.id)
            : this.$cadastrarPeriodoFormacao(payload);
        });
      };
      if (this.$validarFormulario("Preencha os campos obrigatórios.")) {
        save().then(({ data }) => {
          this.$notifySuccess(data.mensagem);
          this.$emit("onClose");
          this.$emit("onSave");
        });
      }
    },
    validateData() {
      if (!this.content.dataInicio || !this.content.dataFim) return true;
      
      const dataInicio = new Date(this.content.dataInicio);
      const dataFim = new Date(this.content.dataFim);
      
      const diffInMilliseconds = dataFim - dataInicio;
      
      const diffInDays = diffInMilliseconds / (1000 * 60 * 60 * 24);
      
      return dataInicio <= dataFim && diffInDays >= 2;
    }
  },
  mounted() {
    this.$buscarPerfis({ params: { situacao: true } }).then(({ data }) => {
      this.form.lists.listPerfis = data.lista;
    });
  }
};
</script>
